var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"boxed unstyle view-select-ac"},_vm._l((_vm.cities),function(city){return (city)?_c('li',{staticClass:"item"},[_c('a',{staticClass:"del-check",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.remove(city)}}},[_vm._v("×")]),_vm._v(_vm._s(city.name)+"\n\t")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }